/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type DismissSkillSuggestionRequestBody = {
  /**
   * The suggestion ID.
   */
  id: string;
};

/** @internal */
export type DismissSkillSuggestionRequestBody$Outbound = {
  id: string;
};

/** @internal */
export const DismissSkillSuggestionRequestBody$outboundSchema: z.ZodMiniType<
  DismissSkillSuggestionRequestBody$Outbound,
  DismissSkillSuggestionRequestBody
> = z.object({
  id: z.string(),
});

export function dismissSkillSuggestionRequestBodyToJSON(
  dismissSkillSuggestionRequestBody: DismissSkillSuggestionRequestBody,
): string {
  return JSON.stringify(
    DismissSkillSuggestionRequestBody$outboundSchema.parse(
      dismissSkillSuggestionRequestBody,
    ),
  );
}
